import BrushIcon from "@mui/icons-material/Brush";
import Box from "@mui/material/Box";
import React from "react";
import { SwatchesPicker } from "react-color";

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
}

export function ColorPicker({ color, onChange }: ColorPickerProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  function toggleOpen() {
    setIsOpen(!isOpen);
  }

  return (
    <Box>
      <Box
        border={1}
        bgcolor={color}
        height={36.5}
        width={64}
        borderRadius={1}
        onClick={() => toggleOpen()}
      >
        <BrushIcon style={{ color: isLightColor(color) ? "black" : "white" }} />
      </Box>
      {isOpen && (
        <Box className="absolute z-10 mt-2">
          <SwatchesPicker
            onChange={(color) => {
              onChange(color.hex);
            }}
          />
        </Box>
      )}
    </Box>
  );
}

// Utility: decide if a color string is light or dark.
export function isLightColor(color: string) {
  if (!color) return true;
  const s = color.trim();
  // handle rgb(...) formats
  if (s.startsWith("rgb")) {
    const nums = s
      .replace(/[^0-9,]/g, "")
      .split(",")
      .map((n) => parseInt(n, 10));
    if (nums.length >= 3) {
      const [r, g, b] = nums;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 155;
    }
  }

  // normalize hex
  let hex = s.replace("#", "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }
  if (hex.length !== 6) return true;
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 155;
}
